import React, { useState } from "react";
import axios from "axios";

export default function SupportChat() {
  const [open, setOpen] = useState(false);
  const [messages, setMessages] = useState([
    { role: "assistant", content: "Hi 👋 I'm Client Exchange support. How can I help you today?" }
  ]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);

  const sendMessage = async () => {
    if (!input.trim()) return;

    const newMessages = [...messages, { role: "user", content: input }];
    setMessages(newMessages);
    setInput("");
    setLoading(true);

    try {
const API_URL =
  window.location.hostname === "localhost"
    ? "http://localhost:5000"
    : "";

const token = localStorage.getItem("token");
const isLoggedIn = !!token;

const SUPPORT_ENDPOINT = isLoggedIn
  ? `${API_URL}/api/support-chat`
  : `${API_URL}/api/support-chat-public`;

const res = await axios.post(
  SUPPORT_ENDPOINT,
  { messages: newMessages },
  isLoggedIn
    ? {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    : {}
);

      setMessages([
        ...newMessages,
        { role: "assistant", content: res.data.reply }
      ]);
    } catch (err) {
      setMessages([
        ...newMessages,
        { role: "assistant", content: "Something went wrong. Please contact support." }
      ]);
    }

    setLoading(false);
  };

  return (
    <>
      {!open && (
        <button
          onClick={() => setOpen(true)}
          style={{
            position: "fixed",
            bottom: 20,
            right: 20,
            zIndex: 9999,
            background: "#2e7d32",
            color: "#fff",
            border: "none",
            borderRadius: "999px",
            padding: "12px 18px",
            fontWeight: "bold",
            boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
            cursor: "pointer"
          }}
        >
          💬 Support
        </button>
      )}

      {open && (
        <div
          style={{
            position: "fixed",
            bottom: 20,
            right: 20,
            width: 320,
            maxWidth: "calc(100vw - 30px)",
            background: "#fff",
            borderRadius: 10,
            boxShadow: "0 0 15px rgba(0,0,0,0.25)",
            display: "flex",
            flexDirection: "column",
            zIndex: 9999,
            overflow: "hidden"
          }}
        >
          <div
            style={{
              padding: 10,
              background: "#2e7d32",
              color: "#fff",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              fontWeight: "bold"
            }}
          >
            <span>Client Exchange Support</span>
            <button
              onClick={() => setOpen(false)}
              style={{
                background: "transparent",
                border: "none",
                color: "#fff",
                fontSize: 18,
                cursor: "pointer"
              }}
            >
              ×
            </button>
          </div>

          <div style={{ flex: 1, padding: 10, overflowY: "auto", maxHeight: 300 }}>
            {messages.map((m, i) => (
              <div
                key={i}
                style={{
                  textAlign: m.role === "user" ? "right" : "left",
                  marginBottom: 8
                }}
              >
                <span
                  style={{
                    background: m.role === "user" ? "#2e7d32" : "#eee",
                    color: m.role === "user" ? "#fff" : "#222",
                    padding: 8,
                    borderRadius: 8,
                    display: "inline-block"
                  }}
                >
                  {m.content}
                </span>
              </div>
            ))}
            {loading && <div style={{ fontSize: 12 }}>Typing...</div>}
          </div>

          <div style={{ display: "flex", borderTop: "1px solid #ddd" }}>
            <input
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") sendMessage();
              }}
              style={{
                flex: 1,
                padding: 10,
                border: "none",
                outline: "none"
              }}
              placeholder="Ask something..."
            />
            <button
              onClick={sendMessage}
              style={{
                padding: "0 14px",
                border: "none",
                background: "#2e7d32",
                color: "#fff",
                fontWeight: "bold",
                cursor: "pointer"
              }}
            >
              Send
            </button>
          </div>
        </div>
      )}
    </>
  );
}